import React from 'react';

import styles from './nav_badge.module.css';

// Outstanding is the number that still needs a review decision. A zero, or a count that has not
// loaded, shows nothing rather than a badge that looks like there is nothing to review.
export default function NavBadge({ outstandingCount }) {
  if (!outstandingCount) {
    return null;
  }

  return (
    <span
      aria-label={`${outstandingCount} outstanding`}
      className={`${styles.badge} ${styles.outstanding}`}
      role='status'
    >
      {outstandingCount}
    </span>
  );
}
